const UnifiedWebSocket = (() => {
  try{
    return WebSocket;
  }catch(err){
    return require('websocket').w3cwebsocket;
  }
})();

const wrapper = {
  message: (myself, event, cb) => {

    const hook = {
      hello: (data) => {
        ['id', 'ip'].forEach(k => myself[k] = data[k]);
      }
    };

    const {data: rawData} = event;

    const data = (() => {
      try{
        return JSON.parse(rawData);
      }catch(err){
        return rawData;
      }
    })();

    const {message, from} = data;

    Object.entries(message).map(([k, v]) => {
      if(hook[k]){
        hook[k](v);
      }
    });

    cb((message) ? message : data, from);
  }
};

const client = (url, subProtocol = 'echo-protocol', origin = undefined) => {

  return new Promise((resolve, reject) => {

    const [app, group, user, argv] = (() => {
      try{
        return new URL(url).pathname.split('/').filter(v => v);
      }catch(err){
        return [];
      }
    })();

    const attr = (!argv) ? null : argv.split(',').reduce((o, v) => {
      const [key, value] = v.split(':');
      return {...o, [key]: value};
    }, {});

    if(!app || !group || !user){
      reject(new Error('url is invalid.'));
    }

    const ws = new UnifiedWebSocket(url, subProtocol, origin),
          myself = {app, group, user, ...attr};

    const client = {

      myself,

      on: (name, cb) => {
        ws['on' + name] = (event) => {
          (wrapper[name]) ? wrapper[name](myself, event, cb) : cb(event);
        };
      },

      send: (data) => {
        ws.send(JSON.stringify((data.message) ? data : {message: data}));
      },

      close: () => {
        ws.close();
      }

    };

    ws.onopen = (event) => {
      client.on('message', () => {});
      resolve(client);
    };

  });
}

module.exports = {client};
